import type { SVGProps } from 'react';

const SvgUserFanLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 25 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M15.7381 14C14.5231 14 13.5381 15.0043 13.5381 16.2432C13.5381 18.4864 16.1381 20.5256 17.5381 21C18.9381 20.5256 21.5381 18.4864 21.5381 16.2432C21.5381 15.0043 20.5531 14 19.3381 14C18.594 14 17.9362 14.3766 17.5381 14.9531C17.1399 14.3766 16.4821 14 15.7381 14Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.53809 21C3.53809 17 6.03809 11.5 12.5381 11'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.5381 11C14.7472 11 16.5381 9.20914 16.5381 7C16.5381 4.79086 14.7472 3 12.5381 3C10.3289 3 8.53809 4.79086 8.53809 7C8.53809 9.20914 10.3289 11 12.5381 11Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgUserFanLt;
